import { render, staticRenderFns } from "./LoginWxBindCallBack.vue?vue&type=template&id=8244a250&scoped=true"
import script from "./LoginWxBindCallBack.vue?vue&type=script&lang=js"
export * from "./LoginWxBindCallBack.vue?vue&type=script&lang=js"
import style0 from "./LoginWxBindCallBack.vue?vue&type=style&index=0&id=8244a250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8244a250",
  null
  
)

export default component.exports